import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "flex flex-col overflow-y-auto p-1 pt-4 space-y-4" }
const _hoisted_3 = { class: "flex flex-col z-10 ml-4 text-white" }
const _hoisted_4 = { class: "text-3xl mb-2" }
const _hoisted_5 = { class: "bg-white border rounded flex items-center justify-center z-10" }
const _hoisted_6 = { class: "flex flex-col items-center justify-between w-full my-5" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "text-lg text-center w-full my-3" }, " Opps, algo deu errado. ", -1)
const _hoisted_8 = { class: "flex justify-center items-center w-full mt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "h-96 rounded-t-lg absolute w-full z-0",
      style: _normalizeStyle({ 'background-color': _ctx.store.data.bgColor})
    }, null, 4),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.store.data.busine), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_Icon, {
            name: "atention",
            color: "#E53935",
            size: "70"
          }),
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleSelect())),
              class: "rounded-full font-regular text-sm flex flex-col justify-center items-center py-2 px-5 cursor-pointer focus:outline-none text-white hover:shadow-xl hover:text-gray-100",
              style: _normalizeStyle({ 'background-color': _ctx.store.data.bgColor})
            }, " Tente novamente ", 4)
          ])
        ])
      ])
    ])
  ]))
}